import { useState, useRef } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import { TimeIcon } from "components/Icons";

import { classNames, colors } from "tools/ui";
import upStore from "store/upStore";
import FormField from "./FormField";
import dates from "tools/dates";
import date from "date-and-time";

const style =
  "outline-none w-full py-2 px-2 rounded-md wrap h-[38px] bg-white events-pointer-none";
const styleIcon = "text-start h-6 w-6 my-auto text-zinc-600 fill-white m-1";
const styleDiv =
  "flatpickr h-10 flex outline-none border border-slate-300 rounded-md focus:border-sky-400 fill-current";

function TimeField(props) {
  const { field, attrs, data } = props;
  const { readOnly, name } = field;
  const { level } = attrs;
  const [state, setState] = useState(false);
  const fp = useRef(null);

  let dateTime = data?.value ?? null;

  function openTimePicker() {
    if (!readOnly) {
      setState((prev) => !prev);
      if (fp.current) {
        state ? fp.current.flatpickr.close() : fp.current.flatpickr.open();
      }
    }
  }

  function handleTimeChange(selectedDates) {
    if (selectedDates.length === 0) return;
    const timeValue = selectedDates[0];
    const formatted = date.format(timeValue, "HH:mm:ss");
    // const formatted = dates.getTrytonTime2Js(new Date(timeValue));

    upStore(level, {
      fieldName: name,
      value: formatted,
      field: field,
    });
  }

  const options = {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    disableMobile: true,
  };

  let color = readOnly ? colors["readOnly"] : "";
  let disable = readOnly ? "pointer-events-none" : "";

  return (
    <FormField {...field}>
      <div className={classNames(styleDiv, color, disable)}>
        <Flatpickr
          ref={fp}
          options={options}
          className={classNames(style, color)}
          value={dateTime ?? null}
          onChange={handleTimeChange}
          onClick={openTimePicker}
        />
        <TimeIcon
          onClick={openTimePicker}
          className={classNames(styleIcon, color)}
          aria-hidden="true"
        />
      </div>
    </FormField>
  );
}

export default TimeField;
